import type { ReschedulingAppointmentConfirmedMessage } from '../../../../../../common/rescheduling';
import MessageContent from '../../../Message/messageContent';
import Appointment, { Status } from '../../GeneralUi/Appointment';

interface Props {
  message: ReschedulingAppointmentConfirmedMessage;
  showTextAnimation: boolean;
}

const AppointmentActionConfirmed: React.FC<Props> = ({
  message,
  showTextAnimation,
}) => {
  const { cancelled, rescheduled } = message.data;

  if (cancelled) {
    return (
      <>
        <MessageContent
          content={message.answer}
          isAgent={true}
          isLoading={false}
          showTextAnimation={showTextAnimation}
        />
      </>
    );
  }
  if (rescheduled) {
    return (
      <>
        <MessageContent
          content={message.answer}
          isAgent={true}
          isLoading={false}
          showTextAnimation={showTextAnimation}
        />
        <Appointment
          appointment={{
            startTime: rescheduled.startTime,
            practice: {
              name: rescheduled.practiceName ?? '',
              phoneNumber: rescheduled.phoneNumber,
              timezone: rescheduled.timezone,
              city: rescheduled.city,
              state: rescheduled.state,
              address: rescheduled.address,
              zip: rescheduled.zipCode,
            },
            provider: {
              firstName: rescheduled.providerFirstName,
              lastName: rescheduled.providerLastName,
              previsitImageUrl: rescheduled.previsitImageUrl,
              prefix: rescheduled.providerPrefix,
              suffix: rescheduled.providerSuffix,
            },
          }}
          status={Status.Rescheduled}
          disabled={true}
        />
      </>
    );
  }
  return <></>;
};

export default AppointmentActionConfirmed;
